import React, { useMemo } from 'react';
import { sortBy } from 'utils/sorting';
import MoreItemsArrow from 'jsx/elements/buttons/MoreItemsArrow';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import SearchBox from 'jsx/elements/inputs/SearchBox';
import DatePicker from 'jsx/elements/inputs/DatePicker';
import Spinner from 'jsx/elements/spinner';

import useIncrement from 'hooks/useIncrement';
import { CREDIT_CATEGORIES } from 'constants/portfolio';
import DDRow from './DDRow';
import CIPRow from './CIPRow';
import CIPStrengthRow from './CIPStrengthRow';

export default function MonitoringList({
  ddState,
  cipState,
  cipStrengthState,
  ddEvents,
  cipEvents,
  cipStrengthEvents,
  dateFrom,
  dateTo,
  search,
  onFromDateChange,
  onToDateChange,
  onSearchChange,
  onSearchSubmit,
}) {
  const { lang, t } = useLocale();
  const categories = CREDIT_CATEGORIES[lang];

  const sorted = useMemo(() => {
    return sortBy(cipEvents.concat(ddEvents, cipStrengthEvents), 'eventDate', 'desc');
  }, [cipEvents, ddEvents, cipStrengthEvents]);

  const [count, increment] = useIncrement(sorted.length, 20, 10);
  return (
    <div style={{ position: 'relative' }}>
      {(ddState === 'loading' || cipState === 'loading' || cipStrengthState === 'loading') && (
        <Spinner relCenter />
      )}

      <div className="monitoring-changes">
        <div className="monitoring-changes--header">
          {/*
        <div className="monitoring-changes--tabs">
          <Button color="blue" text={t('paymentBehavior_monitor_tab_notifications')} />
          <Button color="gray-light" text={t('paymentBehavior_monitor_tab_all')} />
        </div>
      */}
          <div className="monitoring-changes--search">
            <SearchBox
              placeholder={t('portfolioMonitoring_monitoringEvents_search_placeholder')}
              onChange={onSearchChange}
              onClick={onSearchSubmit}
              enterKeySubmit
              value={search}
            />
            <div className="monitoring-changes--search-dates">
              <div className="half-spacing-left">
                <span className="text-14 text-gray text-semibold half-spacing-left half-spacing-right">
                  {t('paymentBehavior_monitor_date_from')}
                </span>
                <DatePicker value={dateFrom} onChange={onFromDateChange} />
              </div>
              <div className="half-spacing-left">
                <span className="text-14 text-gray text-semibold half-spacing-left half-spacing-right">
                  {t('paymentBehavior_monitor_date_to')}
                </span>
                <DatePicker value={dateTo} onChange={onToDateChange} />
              </div>
            </div>
          </div>
        </div>

        {sorted.length === 0 && (
          <div className="text-center box">
            <p>{t('misc_noRecordsFound')}</p>
          </div>
        )}

        {sorted.length !== 0 && (
          <div className="table-wrap">
            <table className="table advanced no-vertical-border">
              <colgroup>
                <col width="15%" />
                <col width="25%" />
                <col width="45%" />
                <col width="15%" />
              </colgroup>
              <tbody>
                {sorted.slice(0, count).map((item) => {
                  if (item.cipCompanyScoreLink !== undefined) {
                    if (!item.newStrengthCategory || !item.oldStrengthCategory) {
                      return <CIPRow item={item} key={item.eventID} categories={categories} />;
                    }
                    return (
                      <CIPStrengthRow item={item} key={item.eventID} categories={categories} />
                    );
                  }
                  return <DDRow item={item} key={item.eventID} />;
                })}
              </tbody>
            </table>
            <div className="half-spacing-top">
              {count < sorted.length && <MoreItemsArrow onClick={increment} />}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
